
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Articles = lazy(() => import('../pages/articles/page'));
const ArticleDynamic = lazy(() => import('../pages/articles/dynamic/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Service pages
const TicaretSirketlerHukuku = lazy(() => import('../pages/services/ticaret-sirketler-hukuku/page'));
const GayrimenkulInsaatHukuku = lazy(() => import('../pages/services/gayrimenkul-insaat-hukuku/page'));
const IsHukukuSosyalGuvenlik = lazy(() => import('../pages/services/is-hukuku-sosyal-guvenlik/page'));
const CezaHukuku = lazy(() => import('../pages/services/ceza-hukuku/page'));
const IcraIflasHukuku = lazy(() => import('../pages/services/icra-iflas-hukuku/page'));
const SozlesmelerHukuku = lazy(() => import('../pages/services/sozlesmeler-hukuku/page'));
const AileHukuku = lazy(() => import('../pages/services/aile-hukuku/page'));
const IdareVergiHukuku = lazy(() => import('../pages/services/idare-vergi-hukuku/page'));
const TazminatHukuku = lazy(() => import('../pages/services/tazminat-hukuku/page'));
const KisiselVerilerinKorunmasi = lazy(() => import('../pages/services/kisisel-verilerin-korunmasi/page'));
const MirasHukuku = lazy(() => import('../pages/services/miras-hukuku/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/services/ticaret-sirketler-hukuku',
    element: <TicaretSirketlerHukuku />
  },
  {
    path: '/services/gayrimenkul-insaat-hukuku',
    element: <GayrimenkulInsaatHukuku />
  },
  {
    path: '/services/is-hukuku-sosyal-guvenlik',
    element: <IsHukukuSosyalGuvenlik />
  },
  {
    path: '/services/ceza-hukuku',
    element: <CezaHukuku />
  },
  {
    path: '/services/icra-iflas-hukuku',
    element: <IcraIflasHukuku />
  },
  {
    path: '/services/sozlesmeler-hukuku',
    element: <SozlesmelerHukuku />
  },
  {
    path: '/services/aile-hukuku',
    element: <AileHukuku />
  },
  {
    path: '/services/idare-vergi-hukuku',
    element: <IdareVergiHukuku />
  },
  {
    path: '/services/tazminat-hukuku',
    element: <TazminatHukuku />
  },
  {
    path: '/services/kisisel-verilerin-korunmasi',
    element: <KisiselVerilerinKorunmasi />
  },
  {
    path: '/services/miras-hukuku',
    element: <MirasHukuku />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/articles',
    element: <Articles />
  },
  {
    path: '/articles/:slug',
    element: <ArticleDynamic />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
